import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
	makeStyles,
	Typography
} from '@material-ui/core';

import Constants from "../utils/Constants";
import HTMLEntities from "../utils/HTMLEntities";
import GoogleLogo from "../assets/google-logo.svg";
import LoadingTextButton from './LoadingTextButton';
import ActivityTitle from "./ActivityTitle";
import TwitterRedaction from "./TwitterRedaction";

const styles = makeStyles(theme => ({
	translateButton: {
		marginLeft: theme.spacing(-1)
	},

	gLogo: {
		height: '1rem',
		marginLeft: theme.spacing(1),
		marginBottom: theme.spacing(-.25)
	},

	gText: {
		textAlign: 'left'
	},

	gIndicator: {
		right: 1,
		top: theme.spacing(0.5)
	}
}));

function Translation(props) {
	const [translationOpen, setTranslationOpen] = useState(false);

	let classes = styles(),
		{language, translated, twitterRedacted,
			translatedTitle, history, category, errorMsg} = props,
		needsTranslation = language !== null && language !== '' && language !== 'en' ? true : false;

	const showTranslation = () => {
		let newVal = !translationOpen;

		setTranslationOpen(newVal);
		if (newVal && !translated) {
			// Only do the translation when toggling to show
			// and if we don't already have the translation
			props.handleTranslateClick();
		}
	};

	translated = HTMLEntities.decode(translated);

	return (
		<React.Fragment>
			{needsTranslation && (!twitterRedacted || twitterRedacted === Constants.ACTIVITY.TWITTER_REDACTION.SCRUB_GEO) ? (
				<LoadingTextButton
					onClick={showTranslation}
					className={classes.translateButton}
					indicatorClassName={classes.gIndicator}
					loading={translationOpen && !translated}>
					{!translationOpen ? 'Translate' : (
						<span className={classes.gText}>
							Translation by Google
							<img src={GoogleLogo} alt="Google" className={classes.gLogo} />
						</span>
					)}
				</LoadingTextButton>
			) : null}
			{translationOpen && (!twitterRedacted || twitterRedacted === Constants.ACTIVITY.TWITTER_REDACTION.SCRUB_GEO) ? (
				translated !== '' ? (
					<React.Fragment>
						<ActivityTitle color="textSecondary" title={translatedTitle} twitterRedacted={twitterRedacted} />
						{twitterRedacted && twitterRedacted !== Constants.ACTIVITY.TWITTER_REDACTION.SCRUB_GEO ? (
							<TwitterRedaction
								twitterRedacted={twitterRedacted}
								history={history}
								isAlert={category === Constants.ACTIVITY.CATEGORIES.ALERTS.ID} />
						) : <Typography>{translated}</Typography>}
					</React.Fragment>
				) : errorMsg === null ? null : <Typography color="textSecondary">{errorMsg}</Typography>
			) : null}
		</React.Fragment>
	);
}

Translation.propTypes = {
	history: PropTypes.object,
	category: PropTypes.number,
	errorMsg: PropTypes.string,
	language: PropTypes.string,
	translated: PropTypes.string,
	handleTranslateClick: PropTypes.func,
	twitterRedacted: PropTypes.string,
	translatedTitle: PropTypes.string
};

export default Translation;